/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Storefront_TitleInputs */

const en_seller_storefront_title = /** @type {(inputs: Seller_Storefront_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Storefront`)
};

const es_seller_storefront_title = /** @type {(inputs: Seller_Storefront_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi tienda`)
};

const fr_seller_storefront_title = /** @type {(inputs: Seller_Storefront_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ma vitrine`)
};

const de_seller_storefront_title = /** @type {(inputs: Seller_Storefront_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Storefront`)
};

const ja_seller_storefront_title = /** @type {(inputs: Seller_Storefront_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイストアフロント`)
};

const zh_seller_storefront_title = /** @type {(inputs: Seller_Storefront_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的店铺`)
};

const ar_seller_storefront_title = /** @type {(inputs: Seller_Storefront_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`واجهة متجري`)
};

const id_seller_storefront_title = /** @type {(inputs: Seller_Storefront_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etalase Saya`)
};

const it_seller_storefront_title = /** @type {(inputs: Seller_Storefront_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La Mia Vetrina`)
};

const ru_seller_storefront_title = /** @type {(inputs: Seller_Storefront_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Моя витрина`)
};

const pt_seller_storefront_title = /** @type {(inputs: Seller_Storefront_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minha Vitrine`)
};

const ko_seller_storefront_title = /** @type {(inputs: Seller_Storefront_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 스토어프론트`)
};

/**
* | output |
* | --- |
* | "My Storefront" |
*
* @param {Seller_Storefront_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_storefront_title = /** @type {((inputs?: Seller_Storefront_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Storefront_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_storefront_title(inputs)
	if (locale === "es") return es_seller_storefront_title(inputs)
	if (locale === "fr") return fr_seller_storefront_title(inputs)
	if (locale === "de") return de_seller_storefront_title(inputs)
	if (locale === "ja") return ja_seller_storefront_title(inputs)
	if (locale === "zh") return zh_seller_storefront_title(inputs)
	if (locale === "ar") return ar_seller_storefront_title(inputs)
	if (locale === "id") return id_seller_storefront_title(inputs)
	if (locale === "it") return it_seller_storefront_title(inputs)
	if (locale === "ru") return ru_seller_storefront_title(inputs)
	if (locale === "pt") return pt_seller_storefront_title(inputs)
	return ko_seller_storefront_title(inputs)
});